import {
  TrucksInArea,
  TrucksInPlantByPointInfo,
  TrucksInPointInfo,
  UnloadingPointAverageDlz,
  UnloadingPointsAverageDlzInfo
} from '../../domain/TrucksInfo';
import {
  TrucksInAreaDTO,
  TrucksInPointInfoDTO,
  TrucksInPlantByPointInfoDTO,
  UnloadingPointAverageDlzDTO,
  UnloadingPointsAverageDlzInfoDTO
} from '../dto/TrucksInfoDTO';

export class TrucksInfoMapper {
  static trucksInAreaToDomain(dto: TrucksInAreaDTO): TrucksInArea {
    return new TrucksInArea(dto.count, dto.transport_ids);
  }

  static unloadingPointAverageDlzToDomain(
    dto: UnloadingPointAverageDlzDTO
  ): UnloadingPointAverageDlz {
    return new UnloadingPointAverageDlz(dto.unloading_point, dto.average_dlz);
  }

  static unloadingPointsAverageDlzInfoToDomain(
    dto: UnloadingPointsAverageDlzInfoDTO
  ): UnloadingPointsAverageDlzInfo {
    return new UnloadingPointsAverageDlzInfo(
      dto.metric,
      dto.last_updated,
      dto.unloading_points.map((item) =>
        this.unloadingPointAverageDlzToDomain(item)
      )
    );
  }

  static trucksInPointInfoToDomain(
    dto: TrucksInPointInfoDTO
  ): TrucksInPointInfo {
    return new TrucksInPointInfo(dto.point, dto.count, dto.transport_ids);
  }

  static trucksInPlantByPointInfoToDomain(
    dto: TrucksInPlantByPointInfoDTO
  ): TrucksInPlantByPointInfo {
    return new TrucksInPlantByPointInfo(
      dto.total_points,
      dto.data.map((item) => this.trucksInPointInfoToDomain(item))
    );
  }

  static trucksInAreaListToDomain(dto: {
    data: TrucksInAreaDTO;
  }): TrucksInArea {
    return this.trucksInAreaToDomain(dto.data);
  }

  static unloadingPointsAverageDlzInfoListToDomain(dto: {
    data: UnloadingPointsAverageDlzInfoDTO;
  }): UnloadingPointsAverageDlzInfo {
    return this.unloadingPointsAverageDlzInfoToDomain(dto.data);
  }

  static trucksInPlantByPointInfoListToDomain(dto: {
    data: TrucksInPlantByPointInfoDTO;
  }): TrucksInPlantByPointInfo {
    return this.trucksInPlantByPointInfoToDomain(dto.data);
  }
}
